<template>
  <component :is="component" v-bind="props" />
</template>

<script setup lang="ts">
import { defineAsyncComponent, computed } from "vue";
import { useUserPreferenceStore } from "@/modules/user-preference/use-user-preference-store";

interface Props {
  noActions?: boolean;
  statusIcon?: string | null;
}

const props = withDefaults(defineProps<Props>(), {
  noActions: false,
  statusIcon: null,
});

const OldAppHeaderContent = defineAsyncComponent(
  () => import("@modules/app/components/AppHeaderContent.vue"),
);
const AppHeaderContent = defineAsyncComponent(
  () => import("@modules/app/v2/components/AppHeaderContent.vue"),
);

const userPreferenceStore = useUserPreferenceStore();

const component = computed(() =>
  userPreferenceStore.isOldHomepageActive ? OldAppHeaderContent : AppHeaderContent,
);
</script>
